import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace CspTidingsInfo {
    /**
    *  获取用户全部消息列表
    */
    export var GetCspTidingsInfoList = (body: any): Promise<any> => {
        return Get(`/csp/CspTidingsInfo/GetCspTidingsInfoList?${qs.stringify(body)}`, {});
    };
    /**
    *  批量修改消息已读
    */
    export var PutUpdateTidingsInfoIsRead = (body: any): Promise<any> => {
        return Put(`/csp/CspTidingsInfo/PutUpdateTidingsInfoIsRead`, body);
    };
    /**
    *  删除消息
    */
    export var DeleteTidingsInfo = (body: any): Promise<any> => {
        return Delete(`/csp/CspTidingsInfo/DeleteTidingsInfo?${qs.stringify(body)}`, {});
    };


}